export const getRiskBadgeClass = (risk) => {
  switch (String(risk || '').toLowerCase()) {
    case 'critical':
      return 'badge';

    case 'high':
      return 'bg-danger';

    case 'medium':
      return 'bg-warning text-dark';

    case 'low':
      return 'bg-success';

    default:
      return 'bg-secondary';
  }
};

export const getRiskBadgeStyle = (risk) => {
  if (String(risk || '').toLowerCase() === 'critical') {
    return {
      backgroundColor: '#8B0000',
      color: '#fff',
    };
  }

  return {};
};

export const getRiskLabel = (risk) => String(risk || 'medium').toUpperCase();
